import { createContext, useContext } from "react"
import { type GlobalContent } from "./types"

export const GlobalContext = createContext<GlobalContent | null | any>(null)

export const useGlobalContext = (): any => useContext(GlobalContext)
